<script setup lang="ts">
const items = [
  {
    title: 'Terhubung Langsung dengan Sistem KiriminAja',
    description: 'Tanpa pindah aplikasi',
    icon: 'material-symbols:connected-tv-outline'
  },
  {
    title: 'Saldo Fleksibel',
    description: 'Isi mulai dari Rp100.000 - Rp2.000.000',
    icon: 'material-symbols:trending-up'
  },
  {
    title: 'Multi User Kontrol',
    description: 'Staff kirim, owner tetap pantau',
    icon: 'material-symbols:spoke-outline'
  },
  {
    title: 'Auto Update Saldo',
    description: 'Saldo real-time setiap transaksi',
    icon: 'ic:baseline-auto-graph'
  },
  {
    title: 'Mendukung ROMS & Pembayaran Paket',
    description: 'Satu saldo banyak fungsi',
    icon: 'material-symbols:fact-check-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Terintegrasi, Real-Time dan Siap untuk Skala Bisnis Kamu"
      />

      <div
        class="flex flex-col gap-6 lg:flex-row lg:flex-wrap lg:justify-center"
      >
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          class="lg:w-96"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
